<template>
    <div class="row" :class="{masque : this.display===true}">
      <div class="Input">
        <label class="checkbox" style="font-size: 15px">
          <input type="checkbox"
            :id="description" 
            @change="change"
            @input="change"
            v-model="Content"
            :placeholder="placeholder"/>
          <div class="check"></div>
        </label>
        <!-- <input class="input" 
        :id="description"
        type="checkbox"
        @change="change"
        @input="change"
        v-model="Content"
        :placeholder="placeholder"
      /> -->
      </div>
      <p :for="description" class="select_title">{{ this.description }}</p>
    </div>    
</template>

<script>
export default {
props:{
    value:{
      required:false
    },
    placeholder:{
      type:String
    },
    display:{
      type:Boolean,
      default:false
    },
    description:{
      type:String
    }
},
data(){
  return {
    content: this.value
  }
},
computed:{
Content:{
  get(){
    return this.content
  },
  set(Content){
        this.content=Content
  }
}
},
methods:{
  change(){
    this.$emit('input', this.content)
    this.$emit('change', this.content)
  },
},

}
</script>

<style scoped lang="scss">
  .row {
    width: 100%;
    display: flex;
    .select_title{
    color: #000000;
    text-align: left;
    font-size: 15px;
    margin-top: 0px;
    margin-bottom: 15px;
  }
    .Input{
      margin-left: 20px;
      width: 10%;
      .input {
      color: #b5bcbd;
      background-color: white;
      padding: 8px;
      border-radius: 7px;
      width: 89%;
      border: 1px solid #a6aeaf;
      margin-top:0px;
      &:focus {
        outline: 0;
      }
      &::placeholder {
        color: #b5bcbd;
      }
    } 
    }
    
}
.masque{
  display: none;
}
</style>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.checkbox {
  background: white;
  display: block;
  font-size: 10vmin;
  width: 1em;
  height: 1em;
  border: 1px #22abc5;
  position: relative;
  cursor: pointer;
  > input {
    opacity: 0;
    position: absolute;
  }
}

.check {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: -3px;
  clip-path: polygon(0 0, 50% 0, 100% 0, 100% 100%, 50% 100%, 0 100%);

  border: solid 2px #22abc5;

  transition: 0.1s, 0s;

  input:checked + & {
    // clip-path: polygon(41% 52%, 26% 35%, 10% 51%, 37% 88%, 37% 88%, 37% 88%, 37% 88%, 37% 88%, 91% 33%, 78% 18%);
    background-color: #22abc5;
    border-color: transparent;
    transition: 0s;

    clip-path: polygon(28% 38%, 41% 53%, 75% 24%, 86% 38%, 40% 78%, 15% 50%);
  }
}
</style>